import { t } from "i18next";
import { DataTableData } from "../../../../components/deprecated/DataTable/DataTable";
import { DataObjectHelper } from "../DataObjects/DataObjectHelper";
import { ReadAccess } from "../AccessData";
import { FirebaseDataCompanyField } from "../DataObjectField/CustomFields/FirebaseDataCompanyField";
import { FirebaseDataContractorField } from "../DataObjectField/CustomFields/FirebaseDataContractorField";
import { FirebaseDataPropertyField } from "../DataObjectField/CustomFields/FirebaseDataPropertyField";
import { FirebaseDataUnitField } from "../DataObjectField/CustomFields/FirebaseDataUnitField";
import { FirebaseDataUserField } from "../DataObjectField/CustomFields/FirebaseDataUserField";

export class ReadAccessDataHelper extends DataObjectHelper<ReadAccess> {
  id = () => "readAccess";

  displayName = () => t("main.accessTo");

  properties = new FirebaseDataPropertyField<ReadAccess>("properties", t("main.properties"), (data) => data.properties);
  companies = new FirebaseDataCompanyField<ReadAccess>("companies", t("main.companies"), (data) => data.companies);
  contractorGroups = new FirebaseDataContractorField<ReadAccess>("contractorGroups", t("main.contractorGroups"), (data) => data.contractorGroups);
  users = new FirebaseDataUserField<ReadAccess>("users", t("main.users"), (data) => data.users);
  propertyUnits = new FirebaseDataUnitField<ReadAccess>("propertyUnits", t("main.propertyUnits"), (data) => data.propertyUnits);

  allFields() {
    return [this.properties, this.companies, this.contractorGroups, this.users, this.propertyUnits];
  }
  getAllDataTableDatas(documents: ReadAccess[]): DataTableData[] {
    return [];
  }
}

